import { isGeneratedFile } from '@angular/compiler/src/aot/util';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Plato } from 'src/app/models/Plato';
import { ApiService } from 'src/app/services/api.service';
import { AppVariablesService } from 'src/app/services/app-variables.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-select-food-by-category',
  templateUrl: './select-food-by-category.page.html',
  styleUrls: ['./select-food-by-category.page.scss'],
})
export class SelectFoodByCategoryPage implements OnInit {

  @Input() category: string;
  foodBaseUrl = 'https://seniors.mensurlabquality.es/devxerintel/api/mensur-smart/platos-residencia';
  platos: Plato[] = [];

  selectedFoods: Plato[] = [];

  constructor(
    private api: ApiService,
    private appVariables: AppVariablesService,
    private utilities: UtilitiesService,
    private modalCtrl: ModalController
  ) { }

  async ngOnInit() {
    let nombreResidencia = 'CUALQUIERA';
    if (this.appVariables.user
      && this.appVariables.user.residence) {
        nombreResidencia = this.appVariables.user.residence.name;
    }
    let fullUrl = `${this.foodBaseUrl}?nombre=${encodeURI(nombreResidencia)}&nombre_categoria=${this.category}`;
    
    await this.utilities.showLoading();

    try {
      this.platos = await this.api.getRequest(fullUrl).toPromise();
      await this.utilities.dismissLoading();
    }
    catch(err) {
      console.log('err = ');
      console.log(err);
      
      await this.utilities.dismissLoading();
      await this.utilities.showToast('Hubo un error al obtener los platos')
    }
  }

  selectFood(plato: Plato) {
    let isSelected = this.selectedFoods.some(item => item.id == plato.id);
    if(isSelected) {
      let index = this.selectedFoods.findIndex(item => item.id == plato.id);
      this.selectedFoods.splice(index, 1);
    }
    else {
      this.selectedFoods.push(plato);
    }
  }

  isSelected(plato: Plato) {
    return this.selectedFoods.some(item => item.id == plato.id);
  }

  confirmSelectedFoods() {
    this.modalCtrl.dismiss(this.selectedFoods);
  }
}
